module.exports = __webpack_public_path__ + "static/img/star_person_team.c085669b.png";